module.exports = __webpack_public_path__ + "img/edtrust.6883b349.png";